export const WHITE = '#FFF';
export const BLACK = '#000';
export const PROCESS_TAG_COLOR = '#9ECFFA40';

export const YELLOW_3 = '#FAAD14';

export const NEUTRAL_8 = '#D9D9D9';

export const PRIMARY = '#2684FF';

export const antColors = {
  default: '#000000d9',
  secondary: '#00000073',
  success: '#52c41a',
  yellow3: '#faad14',
  danger: '#ff4d4f',
};
